import styled from 'styled-components';

export { Indent } from '../pages/login/email/form.styles';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--gap);
`;
